<section class="testimonials">
  <div class="testimonials__inner">

    <div class="testimonials__heading">
      <h2 class="h2" style="color: var(--color-neutral-100);">Más que un taller, una experiencia</h2>
      <p class="body-m" style="color: var(--color-neutral-100); opacity: 0.85;">
        Así lo cuentan quienes ya han pasado por Aruma
      </p>
    </div>

    <div class="testimonials__content">
      @if (active(); as t) {
        <article class="testimonials__card">
          <blockquote class="testimonials__quote">{{ t.quote }}</blockquote>
          <footer class="testimonials__user">
            <span class="testimonials__name body-m">{{ t.name }}</span>
            <span class="testimonials__taller body-xs">{{ t.taller }}</span>
          </footer>
        </article>
      }

      @if (hasMore()) {
        <button type="button" class="testimonials__more" (click)="showMore()">
          Ver más opiniones
        </button>
      }
    </div>

  </div>
</section>
